import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% { transform: scale(0.95); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.7; }
`

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Container = styled.div`
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 20;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.9rem;
  padding: 1rem 1.25rem;
  border-radius: 18px;
  background: linear-gradient(135deg, #0f172a 0%, #141a31 55%, #1f2340 100%);
  color: #f8fafc;
  box-shadow: 0 18px 48px rgba(8, 12, 34, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  overflow: hidden;

  @media (max-width: 640px) {
    left: 1rem;
    right: 1rem;
  }
`

export const Glow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 15% 20%, rgba(255, 255, 255, 0.12), transparent 35%),
    radial-gradient(circle at 80% 10%, rgba(255, 255, 255, 0.1), transparent 40%);
  pointer-events: none;
`

export const IconCircle = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #fbbf24, #f59e0b);
  position: relative;
  overflow: hidden;

  img {
    max-width: 32px;
    animation: ${pulse} 2.2s ease-in-out infinite;
  }

  .ping {
    position: absolute;
    inset: -4px;
    border-radius: inherit;
    background: rgba(255, 255, 255, 0.24);
    filter: blur(10px);
    animation: ${pulse} 2.2s ease-in-out infinite;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  span {
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-size: 0.75rem;
    font-weight: 700;
    color: #cbd5e1;
  }

  strong {
    font-size: 0.95rem;
    color: #ffffff;
  }
`

export const Progress = styled.div`
  margin-top: 0.25rem;
  position: relative;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(250, 204, 21, 0), rgba(250, 204, 21, 0.85), rgba(250, 204, 21, 0));
    animation: ${shimmer} 1.5s linear infinite;
  }
`

export const Spinner = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.18);
  border-top-color: #fbbf24;
  animation: ${spin} 1s linear infinite;
`
